import React from "react";
import { Box, Container, Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { retrieveBestSellers } from "./selector";
import { Product } from "../../../lib/types/product";
import { serverApi } from "../../../lib/config";
import { useHistory } from "react-router-dom";

const bestSellersRetriever = createSelector(
  retrieveBestSellers,
  (bestSellers) => ({ bestSellers })
);

export default function PopularBooks() {
  const { bestSellers } = useSelector(bestSellersRetriever);
  const history = useHistory();
  const featuredBook = bestSellers[0];
  const shelfBooks = bestSellers.slice(1, 7);

  const chooseBookHandler = (id: string) => {
    history.push(`/products/${id}`);
  };

  const getImagePath = (product: Product) =>
    product.productImages?.[0] ? `${serverApi}/${product.productImages[0]}` : "";

  const hideBrokenImage = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <div className={"popular-dishes-frame"}>
      <Container>
        <Stack className={"popular-section"}>
          <Stack className={"section-heading"}>
            <span className={"section-kicker"}>Reader favorites</span>
            <Box className={"category-title"}>This Month Bestsellers</Box>
            <p>
              Hand-picked books with strong reader interest and trusted authors.
            </p>
          </Stack>

          {featuredBook ? (
            <div className={"bestseller-showcase"}>
              <article
                className={"shelf-feature"}
                onClick={() => chooseBookHandler(featuredBook._id)}
              >
                <div className={"shelf-cover-wrap"}>
                  <span className={"shelf-badge"}>#1 bestseller</span>
                  <div className={"shelf-cover"}>
                    {getImagePath(featuredBook) && (
                      <img
                        src={getImagePath(featuredBook)}
                        alt=""
                        onError={hideBrokenImage}
                      />
                    )}
                  </div>
                </div>

                <div className={"shelf-copy"}>
                  <span className={"section-kicker"}>Featured pick</span>
                  <h3>{featuredBook.productName}</h3>
                  <p>{featuredBook.productAuthor}</p>
                  <div className={"shelf-meta"}>
                    <strong>${featuredBook.productPrice}</strong>
                    <span>
                      <FavoriteIcon fontSize="inherit" />{" "}
                      {featuredBook.productLikes}
                    </span>
                    <span>
                      <VisibilityIcon fontSize="inherit" />{" "}
                      {featuredBook.productViews}
                    </span>
                  </div>
                  <button type="button" className={"shelf-button"}>
                    View book details
                  </button>
                </div>
              </article>

              <div className={"shelf-list"}>
                <div className={"shelf-list-head"}>
                  <span>Top shelf</span>
                  <strong>{bestSellers.length} books</strong>
                </div>

                {shelfBooks.map((product: Product, index: number) => (
                  <article
                    className={"shelf-row"}
                    key={product._id}
                    onClick={() => chooseBookHandler(product._id)}
                  >
                    <div className={"shelf-row-cover"}>
                      {getImagePath(product) && (
                        <img
                          src={getImagePath(product)}
                          alt=""
                          onError={hideBrokenImage}
                        />
                      )}
                      <span>#{index + 2}</span>
                    </div>

                    <div className={"shelf-row-copy"}>
                      <h4>{product.productName}</h4>
                      <p>{product.productAuthor}</p>
                    </div>

                    <strong>${product.productPrice}</strong>
                  </article>
                ))}
              </div>
            </div>
            ) : (
            <Box className="no-data">Books are not available yet.</Box>
          )}
        </Stack>
      </Container>
    </div>
  );
}
